export const APP_NAME = "GESTUREVERSE";

export const FACE_HORIZONTAL_EXPAND = 0.4;
export const FACE_VERTICAL_EXPAND = 0.6;
export const FACE_UPWARD_BIAS = 0.1;
export const FACE_SCORE_THRESHOLD = 0.62;
export const FACE_STALE_MS = 140;
export const FACE_HOLD_MS = 180;
export const FACE_RECOVER_FRAMES = 8;
export const FALLBACK_UPPER_FRACTION = 0.45;
export const MAX_SAFETY_UPPER_FRACTION = 0.5;

export const HAND_COUNT = 2;
export const HAND_PRESENCE_THRESHOLD = 0.55;
export const GESTURE_ENTER_FRAMES = 4;
export const GESTURE_EXIT_FRAMES = 3;
export const FIST_STABLE_FRAMES = 5;
export const PINCH_ENTER = 0.32;
export const PINCH_EXIT = 0.44;
export const TWO_HAND_NEAR = 0.22;
export const TWO_HAND_FAR = 0.52;
export const BLACK_HOLE_HOLD_MS = 650;
export const SUPERNOVA_COOLDOWN_MS = 1400;
export const FORMATION_COOLDOWN_MS = 1200;
export const SWIPE_MIN_DELTA = 0.11;
export const SWIPE_WINDOW_MS = 280;
export const TITLE_FADE_MS = 3000;
export const RECORD_COUNTDOWN_MS = 3000;

export const PARTICLE_COUNTS = {
  low: 12000,
  medium: 28000,
  high: 52000,
} as const;

export const THEMES = {
  nebula: ["#00f0ff", "#3d8cff", "#b14dff", "#ff2bd6", "#e8f4ff"],
  aurora: ["#4dffc4", "#00f0ff", "#3d8cff", "#b14dff", "#e8f4ff"],
  ember: ["#ffb347", "#ff5c33", "#ff2bd6", "#ffe08a", "#fff4dc"],
  mono: ["#e8f4ff", "#9ad0f0", "#ffffff", "#7aa7c7", "#d7eaf8"],
} as const;

export const FORMATION_ORDER = [
  "spiral-galaxy",
  "saturn",
  "heart",
  "dna-helix",
  "star-sphere",
  "accretion-disc",
] as const;

export const FORMATION_LABELS: Record<(typeof FORMATION_ORDER)[number], string> = {
  "spiral-galaxy": "SPIRAL GALAXY",
  saturn: "SATURN RINGS",
  heart: "HEART",
  "dna-helix": "DNA HELIX",
  "star-sphere": "STAR SPHERE",
  "accretion-disc": "ACCRETION DISC",
};

export const WASM_PATH = "/wasm";
export const HAND_MODEL_PATH = "/models/hand_landmarker.task";
export const FACE_MODEL_PATH = "/models/blaze_face_short_range.tflite";

export const RECORDING_MIME_CANDIDATES = [
  "video/webm;codecs=vp9,opus",
  "video/webm;codecs=vp8,opus",
  "video/webm;codecs=vp9",
  "video/webm;codecs=vp8",
  "video/webm",
  "video/mp4;codecs=avc1.42E01E,mp4a.40.2",
  "video/mp4",
] as const;

export const SETTINGS_STORAGE_KEY = "gestureverse.settings.v1";
